/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Claim_BtnInputs */



/**
* | output |
* | --- |
* | "Claim" |
*
* @param {Profile_Claim_BtnInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_claim_btn = /** @type {((inputs?: Profile_Claim_BtnInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Claim_BtnInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Revendiquer")
	if (locale === "es") return /** @type {LocalizedString} */ ("Reclamar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Reivindicar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Reclama")
	return /** @type {LocalizedString} */ ("Claim")
});